<template>
    <div>
        <div class="loader" :class="{ show: $store.state.isLoading}">
            <div class="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div class="loader-text">{{$store.state.loaderText}}</div>
            <div class="loader-close" v-if="$store.state.loaderClosable" @click="closeLoader()"><i :class="`${$store.state.faClass} fa-times`"></i></div>
        </div>
        <div class="container" :key="$store.state.debug.formFill">
            <form class="form-container" novalidate>
                <Navigation />
              <div v-if="$store.state.debug.enabled && $store.getters.activeStep">_presetDates: {{ $store.getters.activeStep._presetDates }} </div>
                <div class="step row">
                    <aside class="d-none d-lg-block side orientation col-4 z-index-2" v-if="showSidebar">
                        <div class="step-info d-flex" v-if="$store.state.showNavigation">
                            <div class="step-number align-self-start flex-shrink-0">{{$store.getters.activeStepIndex + 1}}</div>
                            <div class="title align-self-center mt-0">{{$store.getters.activeStep.title}}</div>
                        </div>
                        <div class="location-info">
                            <div class="address">
                                <div class="name">
                                  <i :class="`${$store.state.faClass} fa-lg fa-fw fa-map-marker-alt`"
                                     role="img" aria-label="Adresse: "
                                  ></i>{{$store.state.contact.name}}
                                </div>
                                <div class="street">{{$store.state.contact.street}}</div>
                                <div class="place">{{$store.state.contact.zip}} {{$store.state.contact.place}}</div>
                            </div>
                            <div class="contact">
                                <div class="heading">
                                  <i :class="`${$store.state.faClass} fa-lg fa-fw fa-comment-alt`" aria-hidden="true"></i>{{$store.state.i18n.contact}}
                                </div>
                                <div class="telephone d-flex align-items-center">
                                  <i :class="`${$store.state.faClass} fa-phone fa-fw me-1`" role="img" aria-label="Telefonnummer: "></i>
                                  {{ $store.state.contact.telephone }}
                                </div>
                                <div class="mobile d-flex align-items-center" v-if="$store.state.contact.mobile">
                                  <i :class="`${$store.state.faClass} fa-mobile-alt fa-fw me-1`" role="img" aria-label="Mobiltelefonnummer: "></i>
                                  {{$store.state.contact.mobile}}
                                </div>
                                <div class="mail d-flex align-items-center" v-if="$store.state.contact.mail">
                                  <i :class="`${$store.state.faClass} fa-envelope fa-fw me-1`" role="img" aria-label="E-Mail-Adresse: "></i>
                                  {{$store.state.contact.mail}}
                                </div>
                            </div>
                        </div>
                    </aside>
                    <div class="side step-main col-12 pt-3"
                         :class="{
                              'reverse-direction': $store.state.reverseDirection,
                              'col-lg-8' : this.showSidebar,
                        }">
                        <div class="traveldate-info ms-4 mb-4 pr-3 fw-bold"
                             v-if="$store.state.travelDate != null && $store.getters.activeStep.type !== 'summary' && $store.state.travelDate.step !== $store.getters.activeStep.index">
                            <i :class="`${$store.state.faClass} fa-edit action-icon`" @click="clickEdit($store.state.travelDate.step)" aria-label="Eingabe bearbeiten"></i> Ihr Reisedatum:
                            {{$store.state.travelDate.text}}
                        </div>
                        <transition name="component-fade" mode="out-in">
                            <component
                                    :ref="'module-'+$store.state.currentStepIndex"
                                    :step="$store.getters.activeStep"
                                    :is="activeStepKey()"
                                    :class="{'was-validated': $store.getters.activeStep.wasValidated}"
                            />
                        </transition>
                    </div>
                </div>

            </form>
          <DataDebug v-if="$store.state.debug.enabled" />
        </div>
    </div>
</template>

<script>
    import Navigation from './components/Navigation'
    import Accommodation from './components/Accommodation'
    import TraveldateOffer from './components/TraveldateOffer'
    import Summary from './components/Summary'
    import Contact from './components/Contact'
    import Diverse from './components/Diverse'
    import DataDebug from './components/partials/DataDebug.vue'

    export default {
        components: {
            Navigation,
            DataDebug,
            step_accommodation: Accommodation,
            step_traveldateoffer: TraveldateOffer,
            step_summary: Summary,
            step_contact: Contact,
            step_diverse: Diverse,
        },
        methods: {
            closeLoader(e) {
                this.$store.commit('setLoading', false);
                this.$store.commit('setLoaderClosable', false);
                this.$store.commit('setLoaderText', {text: this.$store.state.i18n.loaderText});
            },
            clickEdit(index) {
                this.$store.state.currentStepIndex = index;
            },
            activeStepKey() {
                return this.$store.getters.activeStepKey;
            },
            fillForm() {
                const store = this.$store;
                if (!store.state.debug.formFill) {
                    return;
                }
                Object.values(store.state.steps).forEach(function (step) {
                    if (store.state.formFillData) {
                        // if (step.isActive) {
                            step.fillDummyData(store);
                        // }
                    } else {
                        step.removeDummyData();
                    }
                });
                if (!store.state.formFillData) {
                    store.commit('resetStep', null);
                }
                store.commit('resetFormInputs', null);
            }
        },
        data() {
            return {
                view: this.activeStepKey()
            };
        },
        computed: {
          showSidebar() {
            return !this.$store.getters.hideSidebar;
          }
        },
        updated() {
            this.fillForm();
        },
        created() {
            // let recaptcha = document.createElement('script');
            // recaptcha.setAttribute('src', "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit async defer");
            // document.head.appendChild(recaptcha);
        }
    }
</script>